import createHistory from 'history/createBrowserHistory'

const history = createHistory()

history.listen(() => {
  window.Intercom('update')
})

export default history
